import React, { useState, useEffect, useRef } from 'react';
import './ClothesChangerWidget.css';
import ClothesChangerGalleryCache from '../utils/ClothesChangerGalleryCache';
import Webcam from 'react-webcam';

var baseURL = "";
if (typeof window.clothesChangerImageData !== 'undefined') {
  baseURL = window.clothesChangerImageData.baseURL || "";
}

const cache = new ClothesChangerGalleryCache();

const ClothesChangerWidget = () => {
  const [mainImage, setMainImage] = useState(null);
  const [faceImage, setFaceImage] = useState(null);
  const [resultImage, setResultImage] = useState(null);
  const [gallery, setGallery] = useState([]);
  const [galleryActiveIndex, setGalleryActiveIndex] = useState(0);
  const [swappingFace, setSwappingFace] = useState(null);
  const [swapped, setSwapped] = useState(false);
  const [showWebcam, setShowWebcam] = useState(false);
  const [showFaceImageMenu, setShowFaceImageMenu] = useState(false);
  const [nsfw, setNsfw] = useState(null);
  const [isPorn, setIsPorn] = useState(false);
  const webcamRef = useRef(null);
  const [category, setCategory] = useState('dress');

  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
  };

  if (typeof window !== 'undefined') {
    window.addEventListener("clothesChangerWidgetDataChange", (e) => {
      if (typeof window.clothesChangerImageData !== 'undefined') {

      }
    });

  }

  const loadNSFW = () => {
    setNsfw(new Worker(`${baseURL}/../face-swap-widget/nsfw.js`));
  }
  useEffect(() => {
    nsfw && nsfw.postMessage(null);
  },[nsfw])
  useEffect(() => {
    async function loadGallery() {
      var gallery = await fetch(`${baseURL}gallery.json`)
        .then(res => res.json());
      var cachedImages = await loadCachedGallery();
      gallery = [...cachedImages.reverse(), ...gallery];
      setGallery(gallery);
    }

    async function loadCachedGallery() {
      var keys = await cache.listGalleryStore();
      return keys;
    };
    loadGallery();
    loadCachedGallery();

    loadNSFW();
  }, [])
  useEffect(() => {
    if (gallery.length > 0) {
      setMainImage(gallery[0]);
      setResultImage(gallery[0]);
    }
  }, [gallery]);

  useEffect(() => {
    //main image changed
    if (!mainImage) {
      return;
    }

    //set the resulting image the same as the main image
    setResultImage(mainImage);
    setSwapped(false);
  }, [mainImage]);

  const getBase64 = (file) => {

    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        reject('Error: ', error);
      };
    });

  }

  const handlePickFromGallery = function (event, idx) {

    var url = event.target.src;
    setGalleryActiveIndex(idx);
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const reader = new FileReader()
        reader.onloadend = () => {
          setMainImage(reader.result);
        }
        // reader.onerror = reject
        reader.readAsDataURL(blob)
      });
  }

  const addToGallery = (img, event) => {
    //add uploade image to gallery
    gallery.unshift(img);
    setGalleryActiveIndex(0);

    var fileName = event.target.files[0].name;
    cache.storeGalleryImage(img, fileName);
  }
  const handleImageChange = async (event, setImage, after) => {

    if (!event.target.files[0]) {
      return;
    }

    nsfw.postMessage(event.target.files[0]);
    const imageUrl = await getBase64(event.target.files[0]);

    nsfw.onmessage = function (event) {
		  var predictions = event.data;
      if (predictions.find(p => p.className === "Porn").probability > 0.5){
        setIsPorn(true);
        console.log("is porn");
        cache.removeGalleryImage(predictions[0].url.name);
      }
    }

    setImage(imageUrl);
    after && after(imageUrl, event);
    
  };

  const handleDrop = async (event, setImage, after) => {
    event.preventDefault();
    const imageUrl = await getBase64(event.dataTransfer.files[0]);
    setImage(imageUrl);
    after && after(imageUrl, event);
  };

  const handleChangeClothes = async () => {
    if (!faceImage) {
      alert("Select model image");
    } else if (!mainImage) {
      alert("Select garment image");
    } else if (isPorn){
      alert("We detected uploaded content that might violate the MockoFun terms and conditions.");
      window.document.location.reload();
      return;
    }
    // Call the face swapping API
    if (faceImage && mainImage) {
      setSwappingFace(true);
      document.querySelector(".result-image").scrollIntoView();
      const apiUrl = '/wp-json/mockofun/v1/change-clothes';
      var headers = {
        'Content-Type': 'application/json',
      };
      if (window.wpApiSettings){
        headers["X-WP-Nonce"] = window.wpApiSettings?window.wpApiSettings.nonce:window.clothesChangerNonce;
      }
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          model_image: faceImage,
          garment_image: mainImage,
          category:category,
          isPorn
        }),
      });

      if (response.status === 500) {
        setSwappingFace(false);
        const result = await response.json();
        alert(result.data);
        return;
      } else if (response.status !== 200) {
        setSwappingFace(false);
        alert("Oooops, there was an error: " + response.statusText + "\n\nPlese try again.");
        return;
      }
      const result = await response.json();

      checkResult(result);
    }
  };

  const checkResult = (response) => {
    const eventSource = new EventSource(`/wp-content/plugins/scene-generator/api/sse-changeclothes-status.php?id=${response.id}`);
    eventSource.onerror = function () { setSwappingFace(false); eventSource.close() }
    eventSource.onmessage = function (event) {
      // console.log(event);
      // Handle the SSE data received from the server
      const response = JSON.parse(event.data);
      switch (response.status) {
        case "COMPLETED":
          console.log(response);
          setResultImage(response.output[0]);
          setSwappingFace(false);
          setSwapped(true);
          eventSource.close();
          break;
        case "failed":
        case "canceled":
          eventSource.close();
          break;
        case "CANCELED":
            eventSource.close();
            break;
        default:
      }
    };
  }

  const swapStatus = function () {
    var status = "";
    if (swappingFace) {
      status = 'working';
    } else if (swapped) {
      status = 'swapped';
    }

    return status;
  }
  const handleDownloadImage = function (event) {
    var a = document.createElement('a');
    a.href = event.target.src;
    var extension = event.target.src.split(";")[0].split("/")[1].replace("jpeg", "jpg");
    a.download = "MockoFun-face-swap." + extension;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  const stopWebcamStream = () => {
    if (webcamRef.current && webcamRef.current.stream) {
      const tracks = webcamRef.current.stream.getTracks();
      tracks.forEach(track => track.stop());
    }
  };

  const handleCameraSnapshotStart = async function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (await requestPermissions()) {
      setShowWebcam(!showWebcam);
    }


  }

  const requestPermissions = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ video: true });
      // Permission granted, set the permissions flag
      return true;
    } catch (error) {
      // Permission denied or an error occurred
      console.error('Webcam permission denied or error:', error);
      return false;
    }
  };

  const captureFaceImage = () => {
    const faceImage = webcamRef.current.getScreenshot();
    // Process the faceImage as needed
    // For now, log the base64 data to the console
    console.log('Captured Face Image:', faceImage);
    setFaceImage(faceImage);
    stopWebcamStream();
    setShowWebcam(false);
  };
  const styles = {
    downloadButton: {
      "--download-img": "url('" + baseURL + "img/download-image.png')"
    }
  }

  if (typeof window !== 'undefined') {
    document.addEventListener('mousedown', function (event) {
      var menu = document.querySelector(".face-image ul.menu");
      if (menu && !menu.contains(event.target)) {
        console.log("clicked outside");
        setShowFaceImageMenu(false);
      }
    });
  }
  return (
    <div className="clothes-changer-container">
      <div
        className="image-placeholder face-image"
        onDrop={(event) => handleDrop(event, setFaceImage)}
        onDragOver={(event) => event.preventDefault()}
        onClick={() => setShowFaceImageMenu(true)/*document.getElementById('faceImageInput').click()*/}
      >

        <input
          id="faceImageInput"
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={(event) => handleImageChange(event, setFaceImage)}
        />
        {faceImage ? <img className="face-image-placeholder" src={faceImage} alt="Face" /> :
          <span className="add-button"><img className="inverted" src={baseURL + 'img/model.png'} alt="Add" /></span>}
        <label>Model Image</label>

        {showFaceImageMenu && <ul className="menu">
          <li onClick={event => { event.stopPropagation(); document.getElementById('faceImageInput').click(); setShowFaceImageMenu(false); }}><img className="camera-snapshot-button" src={baseURL + 'img/clothes.png'} alt="Upload from computer" title="Upload Image" /> Upload Image</li>
          <li onClick={event => { handleCameraSnapshotStart(event); setShowFaceImageMenu(false); }}><img className="camera-snapshot-button" src={baseURL + 'img/camera.png'} alt="Camera Snapshot" title="Add Camera Snapshot" /> Take Snapshot</li>
        </ul>}


        {showWebcam &&
          <div className="camera-snapshot-preview-wrap" onClick={event => event.stopPropagation()}>

            <Webcam
              className="camera-snapshot-preview"
              audio={false}
              height={200}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              width={200}
              onClick={event => { event.stopPropagation(); captureFaceImage(); }}
            />
            <div className='close' onClick={event => { stopWebcamStream(); setShowWebcam(false); event.stopPropagation(); }}>✖</div>
            <img onClick={event => { event.stopPropagation(); captureFaceImage(); }} className="camera-take-snapshot inverted" src={baseURL + 'img/camera.png'} alt="Take Snapshot" title="Take Snapshot" />
          </div>}
      </div>



      <div className="gallery">
        <div
          className="image-placeholder main-image"
          onDrop={(event) => handleDrop(event, setMainImage, addToGallery)}
          onDragOver={(event) => event.preventDefault()}
          onClick={() => document.getElementById('mainImageInput').click()}
        >

          <input
            id="mainImageInput"
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={(event) => handleImageChange(event, setMainImage, addToGallery)}
          />
          {/* {mainImage && <img src={mainImage} alt="Main" />} */}
          <img src={baseURL + 'img/clothes.png'} alt="Add/Upload" />
        </div>

        {gallery && gallery.map && gallery.map((item, idx) =>
        (
          <div className={"image-placeholder " + (idx === galleryActiveIndex ? "active" : "")} key={"img" + idx}>
            <img onClick={(event) => handlePickFromGallery(event, idx)} src={item} alt={"Image " + idx} />
          </div>
        )

        )}
      </div>
      <div class="category-selector">
        <label htmlFor="category">Clothing type:</label>
        <select id="category" value={category} onChange={handleCategoryChange}>
          <option value="">Select a category</option>
          <option value="dress">Upper &amp; Lower Body (dress, etc.b)</option>
          <option value="upperbody">Upper Body (tshirt, blouse, etc.)</option>
          <option value="lowerbody">Lower Body (trousers, skirt, etc.)</option>
        </select>
      </div>
      {resultImage &&
        <div onClick={event => swapped && handleDownloadImage(event)} className="result-image" style={styles.downloadButton}>
          <img className={swapStatus()} src={resultImage} alt="Result" />
        </div>}
      <div className="button-wrap">
        <button onClick={handleChangeClothes}>&#x2728; Change Clothes</button>
      </div>
    </div>
  );
};


// if (typeof window !== 'undefined') {
//   window.FaceSwapWidget = FaceSwapWidget;
// }

export default ClothesChangerWidget;
